import { render, staticRenderFns } from "./WidgetModule.vue?vue&type=template&id=6dda2b5e&"
import script from "./WidgetModule.vue?vue&type=script&lang=ts&"
export * from "./WidgetModule.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports